<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fa fa-suitcase" aria-hidden="true"></i> {{ "TITLE.ADD-ROLE" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="roleForm">
      <div class="form-group">
        <label for="abbreviationInput"><b>{{ "LABEL.ABBREVIATION" | translate }}</b></label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-text-width"></i></div>
          </div>
          <input type="text"
                 id="abbreviationInput"
                 class="form-control"
                 placeholder="{{ 'MESSAGE.ENTER-ROLE-ABBREVIATION' | translate }}"
                 [(ngModel)]="role.abbreviation"
                 formControlName="abbreviation"
                 [class.is-invalid]="isInvalidControl('abbreviation')">
        </div>
        <small *ngIf="isInvalidControl('abbreviation')"
               class="text-danger">
          {{ "MESSAGE.YOU-MUST-ENTER-ROLE-ABBREVIATION" | translate }}
        </small>
      </div>
      <div class="form-group">
        <label for="nameInput"><b>{{ "LABEL.NAME" | translate }}</b></label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-text-height"></i></div>
          </div>
          <input type="text"
                 id="nameInput"
                 class="form-control"
                 placeholder="{{ 'MESSAGE.ENTER-ROLE-NAME' | translate }}"
                 [(ngModel)]="role.name"
                 formControlName="name"
                 [class.is-invalid]="isInvalidControl('name')">
        </div>
        <small *ngIf="isInvalidControl('name')"
               class="text-danger">
          {{ "MESSAGE.YOU-MUST-ENTER-ROLE-NAME" | translate }}
        </small>
      </div>
      <div class="form-group">
        <label for="nameInput"><b>{{ "LABEL.DESCRIPTION" | translate }}</b></label>
        <textarea type="text"
                  id="descriptionInput"
                  class="form-control"
                  placeholder="{{ 'MESSAGE.ENTER-ROLE-DESCRIPTION' | translate }}"
                  [(ngModel)]="role.description"
                  formControlName="description"
                  [class.is-invalid]="isInvalidControl('description')">
        </textarea>
        <small *ngIf="isInvalidControl('description')"
               class="text-danger">
          {{ "MESSAGE.YOU-MUST-ENTER-ROLE-DESCRIPTION" | translate }}
        </small>
      </div>
      <div class="row">
        <div class="col" *ngIf="!isNewRole">
          <label for="state" class="col-form-label">{{ "LABEL.STATE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="{{isActive ? 'input-group-text': 'input-group-text-danger' }}"><i
                class="{{isActive ? 'fas fa-toggle-on': 'fas fa-toggle-off' }}"></i></div>
            </div>
          <select class="form-control"
                  id="state"
                  formControlName="status"
                  [(ngModel)]="role.active"
                  [class.is-invalid]="isInvalidControl('status')">
            <option [value]="1">{{ "LABEL.ACTIVE" | translate }}</option>
            <option [value]="0">{{ "LABEL.INACTIVE" | translate }}</option>
          </select>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
